/**
 * Because of some weird quirk of Next Auth with our OAuth, it's possible for a session
 * to simultaneously be marked as "authenticated" while also having an expired access token
 *
 * So we need this to verify whether a session is _really_ active or not, and to enforce type
 * safety
 */

import { useSession } from 'next-auth/react';
import { PossibleZillowSession } from '../ZillowSessionManager';

export const useZillowSession = () => {
    const { data, ...rest } = useSession();

    const session = data as PossibleZillowSession;
    if (!session) {
        return {
            ...rest,
            session,
        };
    }
    return {
        session,
        ...rest,
    };
};
